import { undefinedOrTransformToDTOCurried } from '@maia/utils';
import { IInvoiceEntity } from '../shared';
import { TagDto } from '@maia/tags';

export class InvoiceDto {
  readonly guid: string;
  readonly reference: string;
  readonly date: Date;
  readonly amount: number;
  readonly status: ReturnType<typeof TagDto.getPaymentStatusTag>;
  readonly paymentRemark: string | null;

  constructor(invoice: IInvoiceEntity) {
    this.guid = invoice.guid;
    this.reference = invoice.reference;
    this.date = new Date(invoice.date);
    this.amount = invoice.amount;
    this.status = TagDto.getPaymentStatusTag(invoice.status);
    this.paymentRemark = invoice.payment_remark;
  }
}

export const undefinedOrInvoice = undefinedOrTransformToDTOCurried(
  (entity) => new InvoiceDto(entity),
);
